import type {SalesRepository} from '../repository/SalesRepository';
import type {Sale} from '../models/sale.model';

export class GetSalesUseCase {
  constructor (private salesRepository: SalesRepository) {}

  async execute (page = 1, limit = 20, filters?: { search?: string; marketerName?: string; marketerId?: string; invoiceNumber?: string }): Promise<{ items: Sale[]; pagination?: any }> {
    return await this.salesRepository.getAllSales(page, limit, filters);
  }
}
